import React, { useState, useEffect } from 'react'
import { X, Download } from 'lucide-react'
import ModalTest from '../../../../components/BaseModal'
import { PDFDownloadLink } from '@react-pdf/renderer'
import BodyOfPDFFashion from '../../../../components/PDF/Fashion/Body'
import { ContainerOfModal, Header, HeaderTitle, CloseDiv, Button } from '../../../../components/styles/modal-style'
import { FashionProductionOrderData } from '../FashionPcp'
import QRCode from 'qrcode'
import FashionApiService from '../../../../services/FashionApiService'

interface GeneratePDFModalFashionProps {
  onClickClose: () => void
  productionOrder: FashionProductionOrderData | null
}

const GeneratePDFModalFashion: React.FC<GeneratePDFModalFashionProps> = ({ onClickClose, productionOrder }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('')
  const [cutterName, setCutterName] = useState<string>('')
  const [dressmakerName, setDressmakerName] = useState<string>('')
  const [fullProductionOrder, setFullProductionOrder] = useState<FashionProductionOrderData | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchFullData = async () => {
      if (productionOrder?.id) {
        try {
          setIsLoading(true)
          const response = await FashionApiService.getProductionOrderById(productionOrder.id)
          setFullProductionOrder(response.data)
        } catch (error) {
          console.error('Erro ao buscar dados completos da ordem de produção:', error)
          setFullProductionOrder(productionOrder)
        } finally {
          setIsLoading(false)
        }
      }
    }

    fetchFullData()
  }, [productionOrder?.id])

  useEffect(() => {
    const generateQRCode = async () => {
      if (fullProductionOrder?.id) {
        try {
          const qrCodeUrl = await QRCode.toDataURL(fullProductionOrder.id.toString(), {
            width: 200,
            margin: 1,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          })
          setQrCodeDataUrl(qrCodeUrl)
        } catch (error) {
          console.error('Erro ao gerar QR code:', error)
        }
      }
    }

    const fetchUserNames = async () => {
      if (fullProductionOrder?.cutterId || fullProductionOrder?.dressmakerId) {
        try {
          const [cuttersResp, dressmakersResp] = await Promise.all([
            fullProductionOrder.cutterId ? FashionApiService.getUsers('Cortador') : Promise.resolve({ data: [] }),
            fullProductionOrder.dressmakerId ? FashionApiService.getUsers('Costureira') : Promise.resolve({ data: [] })
          ])

          const cutters = cuttersResp.data || []
          const dressmakers = dressmakersResp.data || []

          const cutter = cutters.find((c: any) => c.id === fullProductionOrder.cutterId)
          const dressmaker = dressmakers.find((d: any) => d.id === fullProductionOrder.dressmakerId)

          if (cutter) {
            setCutterName(cutter.name || '')
          }
          if (dressmaker) {
            setDressmakerName(dressmaker.name || '')
          }
        } catch (error) {
          console.error('Erro ao buscar nomes dos usuários:', error)
        }
      }
    }

    if (fullProductionOrder) {
      generateQRCode()
      fetchUserNames()
    }
  }, [fullProductionOrder?.id, fullProductionOrder?.cutterId, fullProductionOrder?.dressmakerId])

  return (
    <ModalTest>
      <ContainerOfModal width='500px'>
        <Header>
          <HeaderTitle>Gerar PDF</HeaderTitle>
          <CloseDiv onClick={onClickClose}>
            <X size={20} />
          </CloseDiv>
        </Header>

        <div>
          <p style={{ marginBottom: '2rem', fontSize: '16px', color: '#666' }}>
            Clique no botão abaixo para baixar o PDF da OP
          </p>

          <PDFDownloadLink
            document={<BodyOfPDFFashion data={fullProductionOrder || productionOrder} qrCodeDataUrl={qrCodeDataUrl} cutterName={cutterName} dressmakerName={dressmakerName} />}
            fileName={`OP-${fullProductionOrder?.id || productionOrder?.id || 'documento'}.pdf`}
          >
            {({ loading }) => (
              <Button disabled={loading || isLoading || !fullProductionOrder || !qrCodeDataUrl}>
                <Download size={16} />
                {loading || isLoading ? 'Preparando...' : 'Baixar PDF'}
              </Button>
            )}
          </PDFDownloadLink>
        </div>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default GeneratePDFModalFashion

